import * as fTypes from "Flow2/components/Share/FlexUpload/FlexUploadConfig/FlexUploadTypes";

export const getArchivNrPreDD = ({ mbox }) => {
    let ddData = [];
    if (mbox) {
        let archivObj = { ...fTypes.ARCHIV_PREFIX_OBJ };
        ddData = archivObj[mbox];
        if (ddData && ddData.length) {
            ddData = ddData.map(item => {
                let id = item;
                if (item === fTypes.ARCHIV_FREE) id = '';
                return { ID: id, DE: item, EN: item };
            });
        }
    }
    return ddData;
}

